import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthShell from "../components/auth/AuthShell";
import { Field, inputCls } from "../components/forms/Fields";
import { api, formatApiError } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <AuthShell title="Choose a new password">
      {done ? (
        <p className="text-sm text-slate-600" data-testid="reset-success">Password updated. <Link to="/login" className="font-semibold text-mint-600">Sign in</Link></p>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <Field label="New password" id="rp"><input id="rp" type="password" minLength={6} required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" /></Field>
          {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
          <button type="submit" data-testid="reset-submit-btn" className="h-12 w-full rounded-xl bg-navy text-sm font-semibold text-white hover:bg-navy-700">Update password</button>
        </form>
      )}
    </AuthShell>
  );
}
